module.exports = __webpack_public_path__ + "img/icon-flag-fr.ed733e43.svg";